import { render, staticRenderFns } from "./PartnerAccess.vue?vue&type=template&id=3d094ec0&scoped=true"
import script from "./PartnerAccess.vue?vue&type=script&lang=js"
export * from "./PartnerAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d094ec0",
  null
  
)

export default component.exports